import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "AddAccountOriginContext" */ "./lazyIndex"), { name: "AddAccountOriginContext" });

export const lazyAddAccountsToPendingList: LazyAction<typeof lazyIndex.addAccountsToPendingList, typeof lazyModule> = new LazyAction(lazyModule, m => m.addAccountsToPendingList);
